// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}

/* Meeting page: contain to viewport, support dynamic viewport on mobile */
.meeting-viewport {
  height: 100vh;
  height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
}

/* Prevent horizontal scrolling on mobile */
* {
  box-sizing: border-box;
}

html, body {
  overflow-x: hidden;
  width: 100%;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".App {\n  width: 100%;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n/* Meeting page: contain to viewport, support dynamic viewport on mobile */\n.meeting-viewport {\n  height: 100vh;\n  height: 100dvh;\n  max-height: 100vh;\n  max-height: 100dvh;\n}\n\n/* Prevent horizontal scrolling on mobile */\n* {\n  box-sizing: border-box;\n}\n\nhtml, body {\n  overflow-x: hidden;\n  width: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
